import { GoBackIcon } from 'components/Icons/GoBackIcon';
import { AppIconButton } from './AppIconButton';

export const GoBackButton = ({
  onClick,
}: {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}) => {
  return (
    <AppIconButton
      aria-label="Go Back"
      pos="absolute"
      top="16px"
      left="24px"
      onClick={onClick}
    >
      <GoBackIcon />
    </AppIconButton>
  );
};
